import { Input } from '@chakra-ui/react'
import { withFormLabel } from '../../hocs/withFormLabel'
import { withFormValidation } from '../../hocs/withFormValidation'
import { withPlaceholder } from '../../hocs/withPlaceholder'

const PlaceholderInput = withPlaceholder(Input)
export const LabeledInput = withFormLabel(PlaceholderInput)
export const TrackedInput = withFormValidation(LabeledInput)
